import { styled } from '@mui/material/styles'
import { IMessage } from '@weblite/ts-action/message'
import { WappMessageIcon } from '$common/icons/wapp-message'
import { ContactIcon } from '$common/icons'
import {
  VideoPlayOutlinedIcon,
  WFileIcon,
  WMusicIcon,
  WPhotoIcon,
  WVoiceIcon,
} from '@weblite/icons'

const Container = styled('div')`
  margin-left: 4px;
  display: flex;
`

const ContactMessageIcon = styled(ContactIcon)(({ theme }) => ({
  color: theme.palette.gray,
  width: '16px',
  height: '16px',
}))

const typeIconMapper: Record<IMessage['type'], React.ElementType> = {
  FILE: WFileIcon,
  WAPP: WappMessageIcon,
  IMAGE: WPhotoIcon,
  VOICE: WVoiceIcon,
  VIDEO: VideoPlayOutlinedIcon,
  AUDIO: WMusicIcon,
  CONTACT: ContactMessageIcon,
  EVENT: null,
  TEXT: null,
  CALL: null,
}

interface Props {
  type: IMessage['type']
}

export function MessageType({ type }: Props) {
  const IconComponent = typeIconMapper[type]

  return IconComponent ? (
    <Container>
      <IconComponent
        sx={{ color: 'neutral500', width: '16px', height: '16px' }}
      />
    </Container>
  ) : null
}
